import React, { forwardRef } from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import RadioQuestion from '../../../molecules/systemGuide/systemGuideAnswers/radioQuestion/RadioQuestion';
import TextQuestion from '../../../molecules/systemGuide/systemGuideAnswers/textQuestion/TextQuestion';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import MultipleQuestion from '../../../molecules/systemGuide/systemGuideAnswers/multipleQuestion/MultipleQuestion';
import DoubleRadioQuestion from '../../../molecules/systemGuide/systemGuideAnswers/doubleRadioQuestion/DoubleRadioQuestion';

const SystemGuideSteps = forwardRef(
  ({ questions, currentStep, locale, t }, ref) => {
    const questionsArray = [questions[currentStep]];
    // const questionsArray = questions[currentStep - 1];

    const renderRadioQuestion = (question) => {
      return (
        <RadioQuestion
          questionId={question.id}
          answers={question.guideAnswers}
          locale={locale}
          hasColumns={question.guideAnswers.length >= 8}
        />
      );
    };

    const renderMultipleQuestion = (question) => (
      <MultipleQuestion question={question} locale={locale} t={t} />
    );

    const renderTextQuestion = (question) => (
      <TextQuestion
        question={question}
        currentStep={currentStep}
        locale={locale}
      />
    );

    const renderInfoStep = (question) => (
      <Stack className="items-center py-4">
        <LinkButton
          textTransform="uppercase"
          href={question.linksInfo[locale]}
          label={question.textsShort[locale]}
          className="w-fit px-6 py-3 bg-[#FEC84B]"
        />
      </Stack>
    );

    const renderLanguageStep = (question) => (
      <DoubleRadioQuestion
        answers={question.guideAnswers}
        questionId={question.id}
        locale={locale}
      />
    );

    const renderQuestion = (question) => {
      if (question.name === 'WHAT_IS_SYSTEM') {
        return renderInfoStep(question);
      }

      switch (question.type) {
        case 'radio':
          return renderRadioQuestion(question);
        case 'checkbox':
        case 'multiple':
          return renderMultipleQuestion(question);
        case 'text':
          return renderTextQuestion(question);
        case 'double_radio':
          return renderLanguageStep(question);
        default:
          console.log(`QUESTION TYPE UNHANDLED: ${question.type}`);
          break;
      }
    };

    return (
      <div className="flex flex-1 flex-col w-full h-auto px-2" ref={ref}>
        {questionsArray.map((question) => {
          const text = question.texts[locale]?.trim();

          return (
            <Stack key={question.id} className="w-full min-w-fit">
              <Stack className="w-full py-6 justify-center">
                <Typography
                  as="h6"
                  fontVariant="h6"
                  className="w-full whitespace-pre-line"
                >
                  {text + (question.required ? '*' : '')}
                </Typography>
              </Stack>

              {renderQuestion(question)}
            </Stack>
          );
        })}
      </div>
    );
  }
);

SystemGuideSteps.displayName = 'SystemGuideSteps';

export default SystemGuideSteps;
